import React from "react";
import { TrophyIcon, FireIcon, ClockIcon } from "@heroicons/react/24/solid";

const CompetitionsTab = () => {
  const upcoming = {
    title: "February Trading Challenge",
    description:
      "Compete with thousands of investors. Highest portfolio growth wins.",
    date: "Starts Feb 15, 2025",
    rewards: "$500 + FinAI Trophy Badge",
    difficulty: "Intermediate",
  };

  const live = [
    {
      id: 1,
      title: "Weekly Speed Trading Sprint",
      participants: 128,
      timeLeft: "2d 14h 22m",
      reward: "$150 Prize Pool",
    },
  ];

  const past = [
    {
      id: 1,
      title: "January Momentum Challenge",
      winner: "Amit Sharma",
      growth: "+22.5%",
    },
  ];

  return (
    <div className="space-y-10 animate-fadeIn">

      {/* TITLE */}
      <div>
        <h2 className="text-3xl font-bold mb-2">Trading Competitions</h2>
        <p className="text-gray-400">
          Join challenges, compete with others, and climb the FinAI rankings.
        </p>
      </div>

      {/* 🔥 LIVE COMPETITIONS */}
      <div>
        <h3 className="text-2xl font-semibold mb-3 flex items-center gap-2">
          <FireIcon className="w-6 h-6 text-red-500" />
          Live Competitions
        </h3>

        {live.length === 0 ? (
          <p className="text-gray-500">No live competitions right now.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {live.map((c) => (
              <div
                key={c.id}
                className="
                  bg-gray-100 dark:bg-gray-800
                  p-6 rounded-xl border
                  border-gray-300 dark:border-gray-700 shadow-xl
                "
              >
                <h4 className="text-xl font-semibold">{c.title}</h4>
                <p className="text-gray-600 dark:text-gray-400 mt-1">
                  Participants: <span className="font-medium">{c.participants}</span>
                </p>

                <div className="flex items-center gap-2 mt-3 text-yellow-400">
                  <ClockIcon className="w-5 h-5" />
                  <span className="font-medium">{c.timeLeft} remaining</span>
                </div>

                <p className="text-green-400 mt-2">{c.reward}</p>

                <button
                  className="
                    mt-4 px-5 py-2 bg-indigo-600 
                    hover:bg-indigo-500 rounded-lg transition
                  "
                >
                  Join Now
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 🏆 UPCOMING COMPETITION */}
      <div>
        <h3 className="text-2xl font-semibold mb-3 flex items-center gap-2">
          <TrophyIcon className="w-6 h-6 text-yellow-400" />
          Upcoming Challenge
        </h3>

        <div
          className="
            bg-white dark:bg-gray-800 p-6 rounded-xl 
            border border-gray-300 dark:border-gray-700 shadow-lg
          "
        >
          <h4 className="text-xl font-bold">{upcoming.title}</h4>

          <p className="text-gray-600 dark:text-gray-400 mt-2">
            {upcoming.description}
          </p>

          <p className="text-gray-500 dark:text-gray-400 mt-2">
            <strong>Date:</strong> {upcoming.date}
          </p>

          <p className="text-green-500 dark:text-green-400 mt-1">
            Rewards: {upcoming.rewards}
          </p>

          <p className="text-indigo-400 mt-1">
            Difficulty: {upcoming.difficulty}
          </p>

          <button
            className="
              mt-4 px-6 py-3 
              bg-indigo-600 hover:bg-indigo-500 
              text-white rounded-lg shadow
            "
          >
            Pre-Register
          </button>
        </div>
      </div>

      {/* 🥇 PAST COMPETITIONS */}
      <div>
        <h3 className="text-2xl font-semibold mb-3">Past Competitions</h3>

        {past.length === 0 ? (
          <p className="text-gray-500">No past competitions available.</p>
        ) : (
          <div className="space-y-4">
            {past.map((c) => (
              <div
                key={c.id}
                className="
                  bg-gray-100 dark:bg-gray-800 
                  p-5 rounded-xl border 
                  border-gray-300 dark:border-gray-700 shadow
                "
              >
                <h4 className="text-lg font-semibold">{c.title}</h4>
                <p className="text-gray-500 dark:text-gray-400 mt-1">
                  Winner: <span className="text-indigo-400">{c.winner}</span>
                </p>
                <p className="text-green-400 mt-1">Growth: {c.growth}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompetitionsTab;
